import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPDateTimeField } from '../components/Table/fields/SPDateTimeField';

export const todo: SchemaWithClient<any> = {
  name: 'To Do',
  pluralName: 'To Do',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      hide: true,
    },
    title: {
      name: 'Title',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
    },
    note: {
      name: 'Note',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
    },
    due_at: {
      name: 'Due at',
      fieldRenderer: SPDateField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'dateTime',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/todos'),
};
